import { render } from "./event_agenda.html?vue&type=template&id=46dec2b2&external"
import script from "./event_agenda.js?vue&type=script&lang=js&external"
export * from "./event_agenda.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__